import {
  Backdrop,
  Button,
  CircularProgress,
  colors,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tab,
  Tabs
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import ConcealableContainer from 'src/components/ConcealableContainer';
import Page from 'src/components/Page';
import TeknsiyenKocuDialog from 'src/components/TeknisyenKocuPopUp';
import axios from 'src/utils/axios';
import { safeParseInt } from 'src/utils/Common';
import {
  loadBaslandiJob,
  removeBaslandiJob,
  saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import { text } from '../../modules/languages/index';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
} from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import {
  addMaterials,
  resetMaterials
} from '../../store/actions/materialActions';
import EkGaranti from './AdditionalWarranty';
import Aeee from './Aeee';
import Answers from './Answers';
import Benchmark from './Benchmark';
import Bulten from './Bulletin';
import Yorum from './Comment';
import TamamlayiciUrunSatis from './ComplementaryProductSales';
import Hizmet from './Defect';
import Aciklama from './Detail';
import Digiport from './Digiport';
import Sonlandir from './FinalProcess';
import Header from './Header';
import Yardimci from './Helper';
import Tarihce from './History';
import Insurance from './Insurance';
import Esleme from './Mapping';
import Okc from './Okc';
import Fotograf from './Photo';
import Yazdir from './Print';
import Urun from './Product';
import Degisim from './ProductChange';
import Bakim from './Repair';
import YolOdeme from './RoadPayment';
import Summary from './Summary';
import Anket from './Survey';
import Dogrulama from './Verification';
import Garanti from './Warranty';
import logger from 'src/utils/logger';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Isler({
  match,
  history,
  tasks,
  resetDefects,
  resetLabours,
  resetMaterials,
  addDefects,
  addLabours,
  addMaterials,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
}) {
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [Loading, setLoading] = useState(true);
  const [readonly, setReadonly] = useState(true);
  const [UserFault, setUserFault] = useState(0);
  const [FarkliModelTalebi] = useState(null);
  const isUserFault = isFault => {
    if (isFault === 1) {
      var hizmet = JSON.parse(localStorage.getItem('baslandiFis'));
      hizmet.HIZMETLER.forEach(Hizmet => {
        if (Hizmet.HIZMET_KODU === 229) {
          let mounted = true;
          axios
            .get(
              '/GetArtemisWarranty/' +
              (hizmet.KUL_MODEL_KODU || '-1') +
              '/' +
              hizmet.UYIL +
              '/' +
              hizmet.UDONEM +
              '/' +
              hizmet.SERINO +
              '/' +
              hizmet.NITELIK_KODU
            )
            .then(response => {
              if (mounted) {
                const Deger = response.data;
                if (
                  Deger[0]?.GARANTI_TIPI === 2 ||
                  Deger[0]?.GARANTI_TIPI === 9 ||
                  Deger[0]?.GARANTI_TIPI === 17
                ) {
                  setUserFault(1);
                } else {
                  setUyari(
                    'Üründe tüketici kaynaklı sorun varsa Garanti Tipi=Memnuniyet seçilmelidir!'
                  );
                  setOpen(true);
                }
              }
            });
        }
      });
    } else {
      setUserFault(0);
    }
  };
  const isFarkliModelTalebi = isFarkliModel => {
    if (isFarkliModel === 1) {
      setUyari(
        'Müşterinin talep ettiği model bilgisi var ise, talep edilen model alanına giriniz.'
      );
      setOpen(true);
    }
  };
  const classes = useStyles();
  const { id, tab: currentTab } = match.params;
  const isler = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(id)) : [];
  let okcVisible = isler.length > 0 && isler[0]?.MaliId.length === 12;
  let aeeeWarning = isler.length > 0 && isler[0]?.URUN_IADE === 1;
  let uyariMetin = isler.length > 0 ? isler[0]?.UYARI_METIN : '';
  let uyariVisible = (isler.length > 0 ? isler[0]?.UYARI_METIN : '').length > 0;
  let InsuranceVisible = isler.length > 0 && isler[0]?.SIGORTA_TALEBI === 1;

  const [teknisyenKocuPopUp, setTeknisyenKocuPopUp] = useState(false);
  const [showAiButton, setShowAiButton] = useState(false);
  const [insuranceOpportunityPopup, setInsuranceOpportunityPopup] = useState(false);

  const handleOpenChatBox = () => setTeknisyenKocuPopUp(true);
  const handleCloseChatBox = () => setTeknisyenKocuPopUp(false);
  const handleCloseInsuranceOpportunity = () => setInsuranceOpportunityPopup(false);


  const Alltabs = [
    {
      value: 'summary',
      index: 0,
      label: 'Müşterİ',
      visible: true,
      component: <Summary FisNo={id} readonly={readonly} />
    },
    {
      value: 'Aciklama',
      index: 1,
      label: text('Acıklama'),
      visible: true,
      component: <Aciklama FisNo={id} readonly={readonly} />
    },
    {
      value: 'Tarihce',
      index: 2,
      label: 'Tarİhçe',
      visible: true,
      component: <Tarihce FisNo={id} readonly={readonly} />
    },
    {
      value: 'montajUygunluk',
      index: 2,
      label: 'Montaj Uygunluk',
      visible:
        window.location.href.includes('test') ||
        window.location.href.includes('local'),
      component: <Answers FisNo={id} readonly={readonly} />
    },
    {
      value: 'Urun',
      index: 3,
      label: text('Urun'),
      visible: true,
      component: <Urun FisNo={id} readonly={readonly} />
    },
    {
      value: 'Garanti',
      index: 4,
      label: 'Garantİ',
      visible: true,
      component: (
        <Garanti FisNo={id} readonly={readonly} UserFault={UserFault} />
      )
    },
    {
      value: 'Bulten',
      index: 5,
      label: text('Bultenler'),
      visible: true,
      component: <Bulten FisNo={id} readonly={readonly} />
    },
    {
      value: 'Yardimci',
      index: 6,
      label: 'T.Destek',
      visible: true,
      component: <Yardimci FisNo={id} readonly={readonly} />
    },
    {
      value: 'Hizmet',
      index: 7,
      label: 'Hİzmet',
      visible: true,
      component: <Hizmet FisNo={id} readonly={readonly} />
    },
    {
      value: 'YolOdeme',
      index: 8,
      label: text('YolOdeme'),
      visible: false,
      component: <YolOdeme FisNo={id} readonly={readonly} />
    },
    {
      value: 'Okc',
      index: 9,
      label: 'ÖKC',
      visible: okcVisible,
      component: <Okc FisNo={id} readonly={readonly} />
    },
    {
      value: 'Fotograf',
      index: 10,
      label: text('Fotograf'),
      visible: true,
      component: <Fotograf FisNo={id} readonly={readonly} />
    },
    {
      value: 'Degisim',
      index: 11,
      label: 'Değİşİm',
      visible: true,
      component: (
        <Degisim
          FisNo={id}
          readonly={readonly}
          isUserFault={isUserFault}
          GUserFault={UserFault}
          GFarkliModelTalebi={FarkliModelTalebi}
          isFarkliModelTalebi={isFarkliModelTalebi}
        />
      )
    },
    {
      value: 'Dogrulama',
      index: 12,
      label: text('Doğrulama'),
      visible: true,
      component: <Dogrulama FisNo={id} readonly={readonly} />
    },
    {
      value: 'Anket',
      index: 13,
      label: 'Anket',
      visible: true,
      component: <Anket FisNo={id} readonly={readonly} />
    },
    {
      value: 'Sonlandir',
      index: 14,
      label: 'İş Emrİ Kapatma',
      visible: true,
      component: (
        <Sonlandir FisNo={id} readonly={readonly} setReadonly={setReadonly} InsuranceVisible={InsuranceVisible} />
      )
    },
    {
      value: 'Yazdir',
      index: 15,
      label: text('Yazdır'),
      visible: true,
      component: <Yazdir FisNo={id} readonly={readonly} />
    },
    {
      value: 'Aeee',
      index: 16,
      label: 'Aeee',
      visible: aeeeWarning,
      component: <Aeee FisNo={id} readonly={readonly} />
    },
    {
      value: 'Esleme',
      index: 17,
      label: 'Eşleme',
      visible: true,
      component: <Esleme FisNo={id} readonly={readonly} />
    },
    {
      value: 'Yorum',
      index: 18,
      label: 'Yorum',
      visible: true,
      component: <Yorum FisNo={id} readonly={readonly} />
    },
    {
      value: 'EkGaranti',
      index: 19,
      label: 'EkGarantİ',
      visible: true,
      component: <EkGaranti FisNo={id} readonly={readonly} />
    },
    {
      value: 'Bakim',
      index: 21,
      label: 'Bakim',
      visible: true,
      component: <Bakim FisNo={id} readonly={readonly} />
    },
    {
      value: 'Sigorta',
      index: 22,
      label: 'Sİgorta',
      visible: InsuranceVisible,
      component: <Insurance FisNo={id} readonly={readonly} />
    },
    {
      value: 'Digiport',
      index: 23,
      label: 'Dİgİport',
      visible: true,
      component: <Digiport FisNo={id} readonly={readonly} />
    },
    {
      value: 'TamamlayiciUrunSatis',
      index: 24,
      label: 'Tamamlayıcı Ürün Satış',
      visible: true,
      component: <TamamlayiciUrunSatis FisNo={id} readonly={readonly} />
    },
    {
      value: 'MusteriUrunTercihi',
      index: 25,
      label: 'Müşterİ Ürün Tercİhİ',
      visible: true,
      component: <Benchmark FisNo={id} readonly={readonly} />
    }
  ];

  const tabs = Alltabs.filter(t => t.visible).map((t, i) => {
    return { ...t, index: i };
  });
  const handleClose = () => {
    setOpen(false);
    if (
      Uyari ===
      'Üründe tüketici kaynaklı sorun varsa Garanti Tipi=Memnuniyet seçilmelidir!' ||
      Uyari ===
      'Müşterinin talep ettiği model bilgisi var ise, talep edilen model alanına giriniz.'
    ) {
      setOpen(false);
    } else {
      history.push('/overview');
    }
  };
  useEffect(() => {
    if (!tasks.loading) {
      const jobs = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(id)) : [];
      if (jobs.length === 0) {
        let informationAlert = `${id} no'lu fiş bulunamadı!...`;
        setUyari(informationAlert);
        setOpen(true);
      }
    }
  }, [history, id, tasks.loading, tasks.tasks]);

  let currentTabIndex = 0;

  if (currentTab !== undefined) {
    currentTabIndex = tabs.filter(d => d.value === currentTab)[0]?.index;
  }
  const [index, setindex] = useState(currentTabIndex);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      if (mounted) {
        setindex(currentTabIndex);
      }
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [currentTabIndex]);
  const current = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(id)) : [];
  const currentFisNo = current[0]?.FisNo;
  const currentKulModelKodu = current[0]?.KUL_MODEL_KODU;

  useEffect(() => {
    if (current && current.length > 0) {
      let curr = current[0];
      if (parseInt(current[0]?.DurumKodu) === 33) {
        setReadonly(false);
        let job = loadBaslandiJob();
        if (job === undefined || job.length === 0) {
          saveBaslandiJob(current[0]);
          curr = current[0];
        } else {
          if (parseInt(job[0]?.FisNo) === parseInt(id)) {
            curr = job[0];
          } else {
            removeBaslandiJob();
            saveBaslandiJob(current[0]);
            curr = loadBaslandiJob()[0];
          }
        }
      }
      var kulModelKodu = curr.KUL_MODEL_KODU;
      var garantiTipi = curr.GARANTI_TIPI;
      var isEcomReturn =
        curr.BasvuruNedeni === 'Online Satış-Sipariş İade Talepleri'
          ? true
          : false;
      var uyil = curr.UYIL;
      var udonem = curr.UDONEM;
      var SerialNr = curr.SERINO || '0';
      if (
        kulModelKodu !== undefined &&
        kulModelKodu !== null &&
        kulModelKodu.length > 0
      ) {
        resetDefects();
        resetMaterials();
        resetLabours();
        getDefectRequest(kulModelKodu, garantiTipi, isEcomReturn);
        getMaterialRequest(
          kulModelKodu,
          garantiTipi,
          1,
          uyil,
          udonem,
          SerialNr
        );
        getLabourRequest(kulModelKodu, garantiTipi, 1);
        if (curr.HIZMETLER) {
          const selectedDefects = [];
          let labours = {};
          let materials = {};
          curr.HIZMETLER.forEach(function (h) {
            selectedDefects.push(h.HIZMET_KODU);
            labours = { ...labours, [h.HIZMET_KODU]: [] };
            materials = { ...materials, [h.HIZMET_KODU]: [] };
          });
          addDefects(selectedDefects);
          if (curr.ISCILIKLER) {
            curr.ISCILIKLER.forEach(function (i) {
              labours[i.HIZMET_KODU] = labours[i.HIZMET_KODU] || [];
              if (i.KUL_ISCILIK_KODU !== undefined && i.KUL_ISCILIK_KODU !== null) {
                labours[i.HIZMET_KODU].push(i.KUL_ISCILIK_KODU.toString());
              }
            });
            addLabours(labours);
          }
          if (curr.MALZEMELER) {
            curr.MALZEMELER.forEach(function (i) {
              if (i.HIZMET_KODU) {
                if (!materials[i.HIZMET_KODU]) {
                  materials[i.HIZMET_KODU] = [];
                }
                if (i.MALZEME_STOK_NO) {
                  materials[i.HIZMET_KODU].push(i.MALZEME_STOK_NO.toString());
                  materials = { ...materials, [i.MALZEME_STOK_NO]: safeParseInt(i.ADET) };
                }
              }
            });
            addMaterials(materials);
          }
        }
      }
    }
    setLoading(false);
    // eslint-disable-next-line
  }, [currentFisNo, currentKulModelKodu]);

  const getAllConversationsControl = () => {
    const data = localStorage.getItem('TeknisyenKocuOpenList');
    return data ? JSON.parse(data) : [];
  };

  useEffect(() => {
    const targetFis = currentFisNo;
    const targetModel = currentKulModelKodu;

    if (!targetFis || !targetModel) return;

    const allConvs = getAllConversationsControl() || [];
    const existingIndex = allConvs.findIndex(c => String(c.KulModelKodu) === String(targetModel));
    const existing = allConvs[existingIndex];

    // DURUM 1: Bu model daha önce sorgulanmış ve localstorage'da kaydı var
    if (existing) {
      setShowAiButton(true); // Buton her zaman görünsün (çünkü veri var)

      // Eğer veri var ama daha önce OTOMATİK açılmadıysa aç
      if (!existing.isAutoOpened) {
        setTeknisyenKocuPopUp(true); // Popup'ı aç
        // Bir daha otomatik açılmaması için durumu güncelle
        allConvs[existingIndex].isAutoOpened = true;
        localStorage.setItem('TeknisyenKocuOpenList', JSON.stringify(allConvs));
      }
      return;
    }

    // DURUM 2: Bu model ilk defa sorgulanıyor (API'ye git)
    axios.get(`GetBankNumbersRelatedReceipts/${targetFis}/${targetModel?.replaceAll('/','')}`)
      .then(response => {
        const hasData = response.data?.length > 0;
        setShowAiButton(hasData);

        if (hasData) {
          // Yeni kaydı oluştur: isAutoOpened: true yaparak ilk açılışı tetiklemiş oluyoruz
          const updatedConvs = [
            ...allConvs,
            {
              KulModelKodu: targetModel,
              Control: true,
              isAutoOpened: true
            }
          ];
          localStorage.setItem('TeknisyenKocuOpenList', JSON.stringify(updatedConvs));
          setTeknisyenKocuPopUp(true);
        }
      })
      .catch(err => {
        setShowAiButton(false);
        logger.error("Artemis API Hatası:", err);
      });
    // eslint-disable-next-line
  }, [currentFisNo, currentKulModelKodu]);

  // Sigorta satış fırsatı kontrolü - Her girişte göster
  useEffect(() => {
    if (!currentFisNo || !InsuranceVisible) return;
    
    // Her seferinde popup'ı göster
    setInsuranceOpportunityPopup(true);
    // eslint-disable-next-line
  }, [currentFisNo, InsuranceVisible]);


  const handleChangeIndex = index => {
    let indexValueId = tabs.filter(d => d.index === index)[0]?.value;
    history.push(indexValueId);
  };
  const handleChange = (event, value) => {
    let indexValue = tabs.filter(d => d.index === value)[0]?.value;
    history.push(indexValue);
  };

  return (
    <Page className={classes.root} title="İş Emri Detayı">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Bilgilendirme'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {Loading || tasks.loading ? (
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth={false}>
          <Header FisNo={id}
            readonly={readonly}
            onOpenAiChat={handleOpenChatBox} // Butona basınca bu tetiklenir
            TeknisyenKocuModelKontrol={showAiButton} // Butonun görünüp görünmeyeceği
          />
          <Tabs
            value={index}
            className={classes.tabs}
            textColor="secondary"
            scrollButtons="on"
            indicatorColor="primary"
            variant="scrollable"
            onChange={handleChange}
          >
            {tabs.map(t => {
              return (
                t.visible && (
                  <Tab key={t.index} label={t.label} value={t.index} />
                )
              );
            })}
          </Tabs>
          <SwipeableViews index={index} onChangeIndex={handleChangeIndex}>
            {tabs.map(t => {
              return t.visible && currentTab === t.value ? (
                <div key={t.index}>
                  {t.component}
                  {uyariVisible && (
                    <div>
                      <br />
                      <br />
                      <br />
                    </div>
                  )}
                </div>
              ) : (
                <div key={t.index}></div>
              );
            })}
          </SwipeableViews>
          <ConcealableContainer show={uyariVisible}>
            <Alert severity={aeeeWarning ? 'warning' : 'success'}>
              {uyariMetin}
            </Alert>
          </ConcealableContainer>
        </Container>
      )}
      {isler[0] && (
        <TeknsiyenKocuDialog
          open={teknisyenKocuPopUp} // State true olunca açılır
          onClose={handleCloseChatBox}
          fisNo={id}
          KUL_MODEL_KODU={isler[0]?.KUL_MODEL_KODU}
          isValidateReceipt={1}
        />
      )}

      {/* Sigorta Satış Fırsatı Popup'ı */}
      <Dialog
        open={insuranceOpportunityPopup}
        onClose={handleCloseInsuranceOpportunity}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#FF9800', color: 'white', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <LocalOfferIcon />
          Sigorta Satış Fırsatı!
        </DialogTitle>
        <DialogContent style={{ marginTop: '20px' }}>
          <DialogContentText style={{ fontSize: '16px', color: '#333' }}>
            Bu iş emri için <strong>sigorta satış fırsatı</strong> bulunmaktadır. Müşterimizi bilgilendirmeyi unutmayın.
            <br /><br />
            Montajı tamamladığınızda <strong>Sigorta</strong> bölümünden müşteriye uygun sigorta ürünlerini sunabilir ve satışı gerçekleştirebilirsiniz.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '16px' }}>
          <Button 
            onClick={handleCloseInsuranceOpportunity} 
            variant="contained"
            style={{ 
              minWidth: '120px', 
              fontWeight: 'bold',
              backgroundColor: '#FF9800',
              color: '#FFFFFF',
              fontSize: '14px',
              padding: '10px 24px'
            }}
          >
            KAPAT
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

Isler.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default connect(state => ({ tasks: state.tasks1 }), {
  resetDefects,
  resetLabours,
  resetMaterials,
  addDefects,
  addLabours,
  addMaterials,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
})(Isler);
